import HttpService from "../util/HttpService";
import {TransactionHistoryFilterDto} from "../dto/TransactionHistoryFilterDto";
import ParamEncrypt from "../util/ParamEncrypt";

const CONTEXT_PATH = "/cwm/api/v2";
const SERVICE_PATH = "/fund-transaction-dta-fetch-service/";

class TransactionFetchService {

    getPortfolioListByCIN = (cinNumber: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-portfolio-list/").concat(ParamEncrypt.encryptData(cinNumber)));
    }
    getPortfolioListForSwitchTransferAndWithdrawal = (cinNumber: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-portfolio-list-for-transfer-switch-withdrawal/").concat(ParamEncrypt.encryptData(cinNumber)));
    }
    getFundListForSwitchTransferAndWithdrawal = (portfolioId: number) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-fund-list-for-transfer-switch-withdrawal").concat("/" + ParamEncrypt.encryptData(String(portfolioId))));
    }
    getCollectionBankList = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-collection-bank-list"));
    }
    getAllFundList = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-all-fund-list"));
    }

    getAvailableBalance = (portfolioId: number, fundId: number) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-available-balance").concat("/" + ParamEncrypt.encryptData(String(portfolioId))).concat("/" + ParamEncrypt.encryptData(String(fundId))));
    }

    checkPortfolioJointAndOperatingInstructionsBothParties = (portfolioId: number, cinNumber: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("check-switch-transaction-document-mandatory/").concat(ParamEncrypt.encryptData(cinNumber)).concat("/" + ParamEncrypt.encryptData(String(portfolioId))));
    }

    getCustomerNameByPortfolioNumber = (portfolioNumber: string, cinNumber: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-customer-name-by-portfolio-number/").concat(ParamEncrypt.encryptData(portfolioNumber)).concat("/").concat(ParamEncrypt.encryptData(cinNumber)));
    }
    getBankAccountList = (cinNumber: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-bank-account-list/").concat(ParamEncrypt.encryptData(cinNumber)));
    }
    getThirdPartyBankTemplateList = (cinNumber: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-third-party-bank-template-list/").concat(ParamEncrypt.encryptData(cinNumber)));
    }

    validateThirdPartyBankTemplateName = (templateName: string, cinNumber: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("validate-third-party-bank-template-name/").concat(ParamEncrypt.encryptData(cinNumber)).concat("/").concat(ParamEncrypt.encryptData(templateName)));
    }
    getPendingSwitchFundRequest = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-pending-switch-fund-request"));
    }
    getPendingTransferFundRequest = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-pending-transfer-fund-request"));
    }
    getPendingWithdrawFundRequest = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-pending-withdraw-fund-request"));
    }

    getWithdrawalFrequencyList = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-withdrawal-frequency-list"));
    }
    getPendingInvestCustomerRequests = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-pending-invest-customer-request-list"));
    }
    getProcessingInvestCustomerRequests = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-processing-invest-customer-request-list"));
    }
    customerCinSuggest = (cinString: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("customer-cin-suggest/").concat(ParamEncrypt.encryptData(cinString)));
    }

    getReconciliationPendingAndManualReconciledBankDetails = (groupId: number) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-reconciliation-pending-and-manual-reconciled-bank-details/").concat(ParamEncrypt.encryptData(String(groupId))));
    }
    getManualReconciledBankDetails = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-manual-reconciled-bank-details"));
    }

    getManualReconciledExcelDetails = (filterDto: any) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-bank-upload-data-filter"), ParamEncrypt.encryptObject(filterDto));
    }

    getManualMappedCustomerInvestRequests = (bankRecordId: number) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-manually-mapped-invest-customer-requests/").concat(ParamEncrypt.encryptData(String(bankRecordId))));
    }

    getAutoReconciledBankDetails = (groupId: number) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-auto-reconciled-bank-details/").concat(ParamEncrypt.encryptData(String(groupId))));
    }

    getReconciliationPendingBankDetails = (groupId: number) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-reconciliation-pending-bank-details/").concat(ParamEncrypt.encryptData(String(groupId))));
    }
    getTransactionHistoryList = (filter: TransactionHistoryFilterDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-transaction-history-list"), ParamEncrypt.encryptObject(filter));
    }

    getTransactionHistoryListForAdmin = (filter: TransactionHistoryFilterDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-transaction-history-list-for-admin"), ParamEncrypt.encryptObject(filter));
    }
    getTransactionHistoryListForDashboard = (filter: TransactionHistoryFilterDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-transaction-history-list-for-dashboard"), ParamEncrypt.encryptObject(filter));
    }
}

const transactionFetchService = new TransactionFetchService();
export default transactionFetchService;